export default __webpack_public_path__ + "static/media/team-3.3a569253.jpg";